const styles = theme => ({
  base: theme.base,
  main: theme.main,
})

export default styles
